import { render, staticRenderFns } from "./galleries.vue?vue&type=template&id=15b3db1d&"
import script from "./galleries.vue?vue&type=script&lang=js&"
export * from "./galleries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports